import { useDeviceModels } from './useDeviceModels';

export interface DeviceModelOption {
  id: string;
  name: string;
  code: string;
  deviceType: string;
  sensors: string[];
  model: 1 | 2;
  firmware: string;
}

/**
 * 서버 장비모델(device_models)을 장비 생성용 옵션으로 변환한다.
 * 빌트인/사용자 모델 구분 없이 서버가 단일 출처다(localStorage·hiddenBuiltins 제거).
 */
export function useDeviceModelOptions(): DeviceModelOption[] {
  const { models } = useDeviceModels();

  return models.map((m) => ({
    id: m.id,
    name: m.name,
    code: m.code,
    deviceType: m.deviceType,
    sensors: m.sensors.map((s) => s.sensorType),
    model: m.growthEnabled ? 2 : 1,
    firmware: (m.firmware ?? '1.0.0').replace(/^v/, ''),
  }));
}
